/* INVELO: policies (modal)
   invelocar.com · suporte@invelocar.com
*/
(function () {
  'use strict';

  var EMAIL = 'suporte@invelocar.com';
  var DOMAIN = 'invelocar.com';
  var MAIL = '<a href="mailto:' + EMAIL + '">' + EMAIL + '</a>';

  var css = document.createElement('style');
  css.textContent =
    '#iv-pol-overlay{display:none;position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,.72);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);align-items:center;justify-content:center;padding:16px;}' +
    '#iv-pol-overlay.open{display:flex;}' +
    '#iv-pol-modal{background:#111318;color:rgba(255,255,255,.78);border:1px solid rgba(184,155,102,.22);border-radius:16px;width:100%;max-width:720px;max-height:88vh;display:flex;flex-direction:column;box-shadow:0 24px 64px rgba(0,0,0,.55);overflow:hidden;font-family:Inter,-apple-system,sans-serif;}' +
    '#iv-pol-header{display:flex;align-items:center;justify-content:space-between;padding:18px 22px;border-bottom:1px solid rgba(255,255,255,.08);flex-shrink:0;}' +
    '#iv-pol-title{font-size:1.05rem;font-weight:700;color:#fff;margin:0;letter-spacing:.02em;}' +
    '#iv-pol-close{background:rgba(255,255,255,.08);border:none;color:#fff;width:32px;height:32px;border-radius:50%;cursor:pointer;font-size:1.05rem;line-height:1;}' +
    '#iv-pol-close:hover{background:rgba(184,155,102,.28);}' +
    '#iv-pol-body{padding:22px 24px 28px;overflow-y:auto;flex:1;font-size:.88rem;line-height:1.75;}' +
    '#iv-pol-body h2{font-size:.92rem;font-weight:700;color:#c9a96e;margin:1.45em 0 .45em;padding-bottom:.28em;border-bottom:1px solid rgba(184,155,102,.22);}' +
    '#iv-pol-body p{margin:.55em 0;}' +
    '#iv-pol-body ul{padding-left:1.25em;margin:.45em 0;}' +
    '#iv-pol-body li{margin-bottom:.35em;}' +
    '#iv-pol-body strong{color:#fff;}' +
    '#iv-pol-body a{color:#d4af7a;}' +
    '#iv-pol-body .iv-pol-date{font-style:italic;color:rgba(255,255,255,.38);font-size:.8rem;margin-bottom:1em;}';
  document.head.appendChild(css);

  var overlay = document.createElement('div');
  overlay.id = 'iv-pol-overlay';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.innerHTML =
    '<div id="iv-pol-modal">' +
      '<div id="iv-pol-header"><h2 id="iv-pol-title"></h2><button type="button" id="iv-pol-close" aria-label="Close">×</button></div>' +
      '<div id="iv-pol-body"></div>' +
    '</div>';
  document.body.appendChild(overlay);

  function closeModal() {
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  document.getElementById('iv-pol-close').addEventListener('click', closeModal);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  var POLICIES = {
    privacidade: {
      title: 'Privacy Policy',
      html:
        '<p class="iv-pol-date">Last updated: August 2026</p>' +
        '<p><strong>INVELO</strong> (' + DOMAIN + ') respects your privacy and processes your personal data in accordance with the General Data Protection Regulation (GDPR, EU Regulation 2016/679) and applicable Portuguese law.</p>' +
        '<h2>1. Data controller</h2>' +
        '<p>The controller of the data collected on ' + DOMAIN + ' is INVELO. Contact: ' + MAIL + '. Operations and shipping base: Lisbon, Portugal.</p>' +
        '<h2>2. What data we collect</h2>' +
        '<ul>' +
          '<li>Identification and contact data: name, delivery address, postal code, city, email, and cell phone number.</li>' +
          '<li>Order data: products purchased, the vehicle you entered (make, model, and year), and communications with customer support.</li>' +
          '<li>Payment data: processed securely by the payment provider. We do not store your full card details.</li>' +
          '<li>Browsing data: IP address, device type, pages visited, and cookies (see the Cookie Policy).</li>' +
        '</ul>' +
        '<h2>3. Purposes and legal basis</h2>' +
        '<ul>' +
          '<li>Processing and delivering your order and providing customer support: performance of the contract.</li>' +
          '<li>Meeting legal, tax, and accounting obligations: legal obligation.</li>' +
          '<li>Marketing emails, only with your consent, which you may withdraw at any time: consent.</li>' +
          '<li>Measuring campaigns and improving the site with cookies, with your consent: consent.</li>' +
        '</ul>' +
        '<h2>4. Who we share data with</h2>' +
        '<p>We share data only with the providers needed to run the store: payment processors, carriers, and, if you allow it, measurement and advertising tools. We do not sell or rent your personal data to third parties.</p>' +
        '<h2>5. International transfers</h2>' +
        '<p>Some providers may process data outside the European Economic Area. In those cases we ensure appropriate safeguards, such as standard contractual clauses approved by the European Commission.</p>' +
        '<h2>6. Retention and security</h2>' +
        '<p>We keep data only as long as needed for the purposes described and for legal obligations. The site runs on HTTPS, and we apply appropriate technical and organizational measures.</p>' +
        '<h2>7. Your rights</h2>' +
        '<p>You have the right to access, rectification, erasure, restriction, portability, and objection, and you may withdraw your consent at any time. To exercise these rights, write to <strong>' + EMAIL + '</strong>.</p>' +
        '<p>You may file a complaint with the Portuguese Data Protection Authority (Comissão Nacional de Proteção de Dados, CNPD: <a href="https://www.cnpd.pt" target="_blank" rel="noopener">www.cnpd.pt</a>).</p>' +
        '<h2>8. Changes</h2>' +
        '<p>We may update this policy. The current version will always be posted here with its date.</p>'
    },
    cookies: {
      title: 'Cookie Policy',
      html:
        '<p class="iv-pol-date">Last updated: August 2026</p>' +
        '<p>Cookies are small files stored on your device when you visit <strong>' + DOMAIN + '</strong>. We use them to run the store, analyze browsing, and, if you allow it, show relevant ads.</p>' +
        '<h2>Types of cookies</h2>' +
        '<ul>' +
          '<li><strong>Strictly necessary:</strong> essential for the site and the checkout process. They do not require consent.</li>' +
          '<li><strong>Analytics:</strong> help us understand how the site is used so we can improve it.</li>' +
          '<li><strong>Advertising:</strong> let us measure campaigns and show relevant ads.</li>' +
        '</ul>' +
        '<h2>Your consent</h2>' +
        '<p>Analytics and advertising cookies are only enabled with your consent. You can decline or change your choice in your browser settings. Withdrawing consent is as easy as giving it.</p>' +
        '<h2>Managing cookies</h2>' +
        '<p>You can block or delete cookies in your browser. Disabling some cookies may affect how the store works. Questions: ' + MAIL + '.</p>'
    },
    termos: {
      title: 'Terms and Conditions',
      html:
        '<p class="iv-pol-date">Last updated: August 2026</p>' +
        '<h2>1. Seller information</h2>' +
        '<p><strong>INVELO</strong> (' + DOMAIN + ') is an online store for premium custom-fit car mats, shipping from Portugal. Contact: ' + MAIL + '.</p>' +
        '<h2>2. Acceptance</h2>' +
        '<p>By purchasing on ' + DOMAIN + ' you accept these Terms, together with the Privacy, Cookie, Shipping, and Returns Policies.</p>' +
        '<h2>3. Products and prices</h2>' +
        '<ul>' +
          '<li>All prices are shown in euros (€) and include VAT at the applicable legal rate.</li>' +
          '<li>Images are for illustration; colors may vary slightly depending on your screen.</li>' +
          '<li>Mats are made to measure for the make, model, and year you enter in the configurator.</li>' +
          '<li>If a price is clearly wrong, we will let you know before shipping: you can confirm at the correct price or cancel for a full refund.</li>' +
        '</ul>' +
        '<h2>4. Purchase process</h2>' +
        '<p>After payment you receive a confirmation email. When your order ships, you receive the tracking number.</p>' +
        '<h2>5. Shipping</h2>' +
        '<p>Ships from Portugal, with free shipping and tracking included. Estimated delivery: 7 to 14 business days.</p>' +
        '<h2>6. Right of withdrawal (14 days)</h2>' +
        '<p>If you are a consumer, you may cancel the contract within 14 calendar days of receipt, without giving a reason (Decree-Law No. 24/2014).</p>' +
        '<h2>7. Legal warranty and satisfaction</h2>' +
        '<p>3-year legal warranty of conformity (Decree-Law No. 84/2021). In addition, a 30-day satisfaction guarantee: if the product does not meet your expectations, we refund your money.</p>' +
        '<h2>8. Customer support</h2>' +
        '<p>Support in Portuguese by email at <strong>' + EMAIL + '</strong>, Monday through Saturday, 8:00 a.m. to 6:00 p.m. (Lisbon time). Replies within 24 to 48 business hours.</p>' +
        '<h2>9. Complaints and disputes</h2>' +
        '<p>You can use the Electronic Complaints Book (Livro de Reclamações Eletrónico) and alternative dispute resolution (see “Complaints Book”).</p>' +
        '<h2>10. Governing law</h2>' +
        '<p>Consumer relationships with customers in Portugal are governed by Portuguese consumer protection law and European Union law.</p>'
    },
    envio: {
      title: 'Shipping and Delivery Policy',
      html:
        '<p class="iv-pol-date">Last updated: August 2026</p>' +
        '<p>We ship throughout Portugal (mainland and islands), with tracking included.</p>' +
        '<h2>1. Shipping cost</h2>' +
        '<p>Shipping is <strong>free</strong> on every order, with no minimum. There are no hidden fees.</p>' +
        '<h2>2. Origin and delivery time</h2>' +
        '<p>Ships from Portugal. Estimated delivery: <strong>7 to 14 business days</strong> after your purchase is confirmed. Domestic shipments: no customs fees.</p>' +
        '<h2>3. Tracking</h2>' +
        '<p>Within 1 to 3 business days after your purchase, you receive the tracking number by email.</p>' +
        '<h2>4. Delays and lost parcels</h2>' +
        '<p>If we exceed the maximum delivery time, contact us: we will reship at no cost or refund 100%, your choice.</p>' +
        '<h2>5. Incorrect address</h2>' +
        '<p>Check your address before completing your order. If you spot a mistake, let us know right away at ' + MAIL + '. If the order has not shipped yet, we will fix it at no cost.</p>'
    },
    devolucoes: {
      title: 'Exchanges, Returns, and Refunds Policy',
      html:
        '<p class="iv-pol-date">Last updated: August 2026</p>' +
        '<p>Shop with peace of mind. You have three levels of protection.</p>' +
        '<h2>1. Right of withdrawal (14 days)</h2>' +
        '<p>You may cancel the contract within <strong>14 calendar days</strong> of receipt, without giving a reason and without penalty (Decree-Law No. 24/2014). 100% refund. We cover the return shipping costs.</p>' +
        '<h2>2. Satisfaction guarantee (30 days)</h2>' +
        '<p>If the product does not meet your expectations, you have <strong>30 days</strong> after receipt to request a refund or exchange, at no cost to you.</p>' +
        '<h2>3. Legal warranty (3 years)</h2>' +
        '<p>Legal warranty of <strong>3 years</strong>. In case of a defect or nonconformity: repair, replacement, price reduction, or cancellation of the contract (Decree-Law No. 84/2021).</p>' +
        '<h2>4. Defective, damaged, or wrong product</h2>' +
        '<p>If it arrives defective, damaged, or different from what you ordered, we fix it at no cost: replacement or a 100% refund, your choice. We only ask for photos or a video of what you received.</p>' +
        '<h2>5. How to request</h2>' +
        '<ul>' +
          '<li>Write to <strong>' + EMAIL + '</strong> with your order number and the reason.</li>' +
          '<li>We reply within 24 to 48 business hours with confirmation and instructions.</li>' +
          '<li>We cover the return shipping costs (prepaid label or reimbursement of the shipping cost).</li>' +
        '</ul>' +
        '<h2>6. Return conditions</h2>' +
        '<ul>' +
          '<li>The product must be unused, in the same condition you received it, and, if possible, in its original packaging.</li>' +
          '<li>This condition does not apply to defective or damaged products, or products sent by mistake.</li>' +
        '</ul>' +
        '<h2>7. Refund</h2>' +
        '<p>Once approved, we process the refund within <strong>2 to 5 days</strong> to the original payment method.</p>'
    },
    aviso: {
      title: 'Legal Notice',
      html:
        '<p class="iv-pol-date">Last updated: August 2026</p>' +
        '<h2>Site owner</h2>' +
        '<p><strong>Brand:</strong> INVELO<br>' +
        '<strong>Domain:</strong> ' + DOMAIN + '<br>' +
        '<strong>Email:</strong> ' + MAIL + '<br>' +
        '<strong>Operations and shipping:</strong> Lisbon, Portugal</p>' +
        '<h2>Business activity</h2>' +
        '<p>INVELO sells premium custom-fit car mats to consumers in Portugal, with domestic shipping and tracking included.</p>' +
        '<p>Consumer relationships in Portugal are governed by Portuguese and European Union consumer protection law, including the 14-day right of withdrawal (Decree-Law No. 24/2014) and the legal warranty of conformity (Decree-Law No. 84/2021).</p>' +
        '<h2>Data protection</h2>' +
        '<p>The processing of personal data is described in the Privacy Policy, in accordance with the GDPR.</p>' +
        '<h2>Intellectual property</h2>' +
        '<p>The INVELO brand, the site design, the texts, and all other content are protected. Reproduction without prior written permission is prohibited.</p>'
    },
    reclamacoes: {
      title: 'Complaints Book and Dispute Resolution',
      html:
        '<p class="iv-pol-date">Last updated: August 2026</p>' +
        '<h2>Electronic Complaints Book (Livro de Reclamações Eletrónico)</h2>' +
        '<p>Under Portuguese law, you may file a complaint in the Electronic Complaints Book:</p>' +
        '<p><a href="https://www.livroreclamacoes.pt" target="_blank" rel="noopener"><strong>www.livroreclamacoes.pt</strong></a></p>' +
        '<p>Complaints are answered within the legal deadline of 15 business days.</p>' +
        '<h2>Alternative dispute resolution (ADR)</h2>' +
        '<p>In a consumer dispute, you may turn to an ADR entity (Law No. 144/2015).</p>' +
        '<p>Competent entity: National Center for Consumer Dispute Information and Arbitration (Centro Nacional de Informação e Arbitragem de Conflitos de Consumo, CNIACC): <a href="https://www.cniacc.pt" target="_blank" rel="noopener">www.cniacc.pt</a>. List of entities: <a href="https://www.consumidor.gov.pt" target="_blank" rel="noopener">www.consumidor.gov.pt</a>.</p>' +
        '<h2>European ODR platform</h2>' +
        '<p>European Commission platform: <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener">ec.europa.eu/consumers/odr</a>.</p>' +
        '<h2>Direct contact</h2>' +
        '<p>Before using these channels, contact us at <strong>' + EMAIL + '</strong>. In most cases we resolve the issue right away.</p>'
    }
  };

  var LINK_MAP = {
    'privacy policy': 'privacidade',
    'cookie policy': 'cookies',
    'terms and conditions': 'termos',
    'shipping and delivery policy': 'envio',
    'shipping policy': 'envio',
    'exchanges and returns policy': 'devolucoes',
    'exchanges and returns': 'devolucoes',
    'legal notice': 'aviso',
    'complaints book': 'reclamacoes'
  };

  function openPolicy(key) {
    var pol = POLICIES[key];
    if (!pol) return;
    document.getElementById('iv-pol-title').textContent = pol.title;
    document.getElementById('iv-pol-body').innerHTML = pol.html;
    document.getElementById('iv-pol-body').scrollTop = 0;
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  window.__inveloPolicy = openPolicy;

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a');
    if (!a) return;
    var key = a.getAttribute('data-policy') || LINK_MAP[(a.textContent || '').trim().toLowerCase()];
    if (!key) return;
    e.preventDefault();
    openPolicy(key);
  });
})();
